export default "__VITE_ASSET__U1Sn7blGKysKHVgZoLyVVQ__"